
export const colors = {
    primary:        '#78E',
    scondary:       '#F9F9FF',
    darkText:       '#445',
    brightText:     '#99A',
    hoverText:      '#AAB',
    blue:           '#1A73E8',
    button:         '#DDDDEA',
    gridBackground: '#F3F3F6',
    teacherLessons: '#E14F53',
    red:            "#EE5C60",

}

export const categories: { [key: string]: any } = {
  "apps":           ['app',           "#78E"],
  "lessons":        ['lesson',        "#29B788"],
  "puzzles":        ['puzzle',        "#9694D5"],
  "interaction":    ['interact',      "#3BD"],
  //"teacherLessons": ['teacherLesson', "#E14C50"],
  "teacherLessons": ['teacherLesson', "#E14245"],
  "teacherContent": ['teacherContent',"#EE5C60"],
 // "mivdakim":       ['mivdak',        "#FA6B5E"],
  "mivdakim":       ['mivdak',        "#F06A49"],
}


/**
 * 
 * 

export const categories: { [key: string]: any } = {
   "apps":           ['app',           "#78E"],
  "lessons":        ['lesson',        "#44BF90"],
  "puzzles":        ['puzzle',        "#9091C2"],
  "interaction":    ['interact',      "#3BD"],
  "teacherLessons": ['teacherLesson', "#EE5C60"],
  "teacherContent": ['teacherContent',"#EE5C60"],
  "mivdakim":       ['mivdak',        "#FF8073"],
}




 */